import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  XCircle,
  AlertTriangle,
  ArrowLeft,
  RefreshCw,
  CreditCard,
  HelpCircle,
  Home,
  FileText,
} from "lucide-react";
import "../CustomCSS/PaymentSuccess.css";
import Header2 from "../Sections/Header";

const PaymentUnsuccessful = () => {
  const [animateIn, setAnimateIn] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    // Trigger animations after component mounts
    setTimeout(() => {
      setAnimateIn(true);
    }, 100);
    // // Show buttons after the error animation
    setTimeout(() => {
      setShowButtons(true);
    }, 1000);
  }, []);

  return (
    <>
      <Header2 />
      <div className="container-fluid py-4">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-5 mt-4">
            {/* Main Error Card */}
            <div className="card border-0 shadow-lg paymentsuccess-card paymentsuccess-error-card">
              {/* Error Animation Container */}
              <div
                className="paymentsuccess-animation-container"
                style={{
                  padding: "1rem",
                }}
              >
                <div
                  className={`paymentsuccess-circle-outer paymentsuccess-error-circle ${
                    animateIn ? "animate" : ""
                  }`}
                  style={{
                    padding: "1rem 0",
                  }}
                >
                  <div
                    className={`paymentsuccess-circle-inner paymentsuccess-error-inner ${
                      animateIn ? "animate" : ""
                    }`}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <XCircle size={40} className="paymentsuccess-error-icon" />
                  </div>
                </div>
                <div
                  className={`paymentsuccess-success-text ${
                    animateIn ? "animate" : ""
                  }`}
                >
                  <h4 className="fw-bold text-center mb-0">Payment Failed</h4>
                  <p className="text-center text-danger mb-0 mt-2">
                    Your payment could not be processed
                  </p>
                </div>
              </div>

              {/* Navigation Buttons */}
              <div
                className={`card-footer bg-white border-0 p-4 paymentsuccess-actions ${
                  showButtons ? "show" : ""
                }`}
              >
                <div className="row g-3 align-items-center">
                  <div className="col-md-6">
                    <button
                      className="btn btn-primary w-100 d-flex align-items-center justify-content-center py-2 paymentsuccess-backNew"
                      onClick={() => navigate(-1)}
                    >
                      <ArrowLeft size={16} className="me-2" />
                      <span className="fw-medium">Back</span>
                    </button>
                  </div>
                  <div className="col-md-6">
                    <button
                      className="btn btn-primary w-100 d-flex align-items-center justify-content-center py-2 paymentsuccess-go"
                      onClick={() => navigate("/")}
                    >
                      <Home size={16} className="me-2" />
                      <span className="fw-medium">Go to Home</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentUnsuccessful;
